import { Config } from '../config';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { PaginatedResponse } from '../models/paginated-response.model';
import { OfferDetailModel, OfferModel } from '../models/wardrobe.model';

@Injectable({
  providedIn: 'root'
})
export class OfferService extends HttpService {

  constructor(
    http: HttpClient,
  ) {
    super(http);
  }

  createOffer(offer: OfferModel) {
    return this.http.post<OfferModel>(`${Config.apiUrl}/offers/save`, offer);
  }

  updateOffer(id: number, status: string, chat_id?: string) {
    var request;
    if (typeof chat_id !== undefined) {
      request = { status, chat_id };
    } else {
      request = { status };
    }
    
    return this.http.put<OfferDetailModel>(`${Config.apiUrl}/offers/${id}`, request);
  }

  offersList(params: { page?: number, per_page?: number, direction?: 'received' | 'sent', product_id?: number }) {
    return this.http.get<PaginatedResponse<OfferDetailModel>>(`${Config.apiUrl}/offers/list`, {
      params: this.serialize(params)
    });
  }

  subscription(data) {
    return this.http.post<any>(`${Config.apiUrl}/subscription/store-data`, data);
  }

}
